import { render } from "./Foto.vue?vue&type=template&id=3c63d993&scoped=true"
import script from "./Foto.vue?vue&type=script&lang=js"
export * from "./Foto.vue?vue&type=script&lang=js"

import "./Foto.vue?vue&type=style&index=0&id=3c63d993&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c63d993"]])

export default __exports__